<template>

  <div class="mt-3 mb-5 ml-3 mr-3" align="center">

    <svg class="ml-5" width="100%" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 772 764.19">
      
      <defs>
        <linearGradient id="linear-gradient" x1="382.37" y1="375.54" x2="382.37" y2="59.44" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#fbd73b"/>
          <stop offset="1" stop-color="#e96100"/>
        </linearGradient>
        <linearGradient id="linear-gradient-2" x1="400.37" y1="401.58" x2="701.19" y2="581.93" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#6c6"/>
          <stop offset=".17" stop-color="#61c964"/>
          <stop offset=".39" stop-color="#52c160"/>
          <stop offset=".62" stop-color="#3ab358"/>
          <stop offset=".86" stop-color="#189f4d"/>
          <stop offset="1" stop-color="#009245"/>
        </linearGradient>
        <linearGradient id="linear-gradient-3" x1="72.07" y1="560.26" x2="368.68" y2="413.29" gradientUnits="userSpaceOnUse">
          <stop offset=".02" stop-color="#0027bf"/>
          <stop offset=".12" stop-color="#1938cb"/>
          <stop offset=".3" stop-color="#3d52de"/>
          <stop offset=".47" stop-color="#5a66ec"/>
          <stop offset=".64" stop-color="#6f74f7"/>
          <stop offset=".81" stop-color="#7b7dfd"/>
          <stop offset=".97" stop-color="#7f80ff"/>
        </linearGradient>
      </defs>

      <g id="Layer_2" data-name="Layer 2">
        <ellipse cx="382" cy="394" rx="349.5" ry="350" stroke="#aaa" stroke-miterlimit="10" stroke-width="4" fill="none" id="Main_Circle" data-name="Main Circle"/>
        
        <g v-if="showTriads" class="triads" id="Triads">
          <path  :class="GutOver ? 'gutOver' : ''" @mouseover="GutOver = true" @mouseleave="GutOver = false" d="M685.31 218.38L382 393.5 79.43 218.81C140 114.3 253 44 382.5 44c129.29 0 242.21 70.11 302.81 174.38z" fill="url(#linear-gradient)" id="GutTriad"/>
          <path :class="HeartOver ? 'heartOver' : ''" @mouseover="HeartOver = true" @mouseleave="HeartOver = false" d="M732 394c0 193.3-156.7 350-350 350h-.5V393.5l303.31-175.12A348.3 348.3 0 01732 394z" fill="url(#linear-gradient-2)" id="HeartTriad"/>
          <path :class="HeadOver ? 'headOver' : ''" @mouseover="HeadOver = true" @mouseleave="HeadOver = false" d="M382.5 393.5V744C189.43 743.73 33 587.13 33 394a348.45 348.45 0 0146.93-175.19z" fill="url(#linear-gradient-3)" id="HeadTriad"/>
        </g>

        
        <g id="_9_Circles" data-name="9 Circles">
        
          <g  @click="typeClicked(7)" @mouseover="typeHover(7)" id="7circleNumber">
            <circle   :class="SevenOver ? 'circleOver' : ''" id="_7circle" data-name="7circle" cx="40" cy="325.5" r="40" fill="#7e00e7"/>
            <text  :class="SevenOver ? 'numberOver' : 'cls-14'" id="num7" transform="translate(25.25 347.71)">
            7
            </text>
          </g>

          <g  @click="typeClicked(6)" @mouseover="typeHover(6)"  id="7circleNumber">
            <circle :class="SixOver ? 'circleOver' : ''"  id="_6circle" data-name="6circle" cx="80.5" cy="561" r="40" fill="#00c5e7"/>
            <text id="num6" :class="SixOver ? 'numberOver' : 'cls-14'" transform="translate(64.25 583.71)">
              6
            </text>
          </g>
          
          <g  @click="typeClicked(5)" @mouseover="typeHover(5)"  id="7circleNumber">
            <circle :class="FiveOver ? 'circleOver' : ''" id="_5circle" data-name="5circle" cx="262.5" cy="718" r="40" fill="#0063d0"/>
            <text id="num5" :class="FiveOver ? 'numberOver' : 'cls-14'" transform="translate(247.25 740.71)">
              5
            </text>
          </g>
          
          <g  @click="typeClicked(4)" @mouseover="typeHover(4)"  id="7circleNumber">
            <circle :class="FourOver ? 'circleOver' : ''" id="_4circle" data-name="4circle" cx="503" cy="718.5" r="40" fill="#008b51"/>
            <text id="num4" :class="FourOver ? 'numberOver' : 'cls-14'" transform="translate(487.25 738.71)">
              4
            </text>
          </g>
          
          <g  @click="typeClicked(3)" @mouseover="typeHover(3)"  id="7circleNumber">
            <circle :class="ThreeOver ? 'circleOver' : ''" id="_3circle" data-name="3circle" cx="686" cy="562.5" r="40" fill="#047300"/>
            <text id="num3" :class="ThreeOver ? 'numberOver' : 'cls-14'" transform="translate(671.86 584.71)">
              3
            </text>
          </g>
          
          <g  @click="typeClicked(2)" @mouseover="typeHover(2)"  id="7circleNumber">
            <circle :class="TwoOver ? 'circleOver' : ''" id="_2circle" data-name="2circle" cx="728" cy="326.5" r="40" fill="#6cd000"/>
            <text id="num2" :class="TwoOver ? 'numberOver' : 'cls-14'" transform="translate(712.86 346.71)">
              2
            </text>
          </g>
          
          <g  @click="typeClicked(1)" @mouseover="typeHover(1)"  id="7circleNumber">
            <circle :class="OneOver ? 'circleOver' : ''" id="_1circle" data-name="1circle" cx="607.5" cy="121" r="40" fill="#f4cd00"/>
            <text id="num1" :class="OneOver ? 'numberOver' : 'cls-14'" transform="translate(590.86 142.71)">
              1
            </text>
          </g>
          
          <g  @click="typeClicked(9)" @mouseover="typeHover(9)"  id="7circleNumber">
            <circle :class="NineOver ? 'circleOver' : ''" id="_9circle" data-name="9circle" cx="382.5" cy="40" r="40" fill="#ffa92e"/>
            <text id="num9" :class="NineOver ? 'numberOver' : 'cls-14'" transform="translate(367.24 60.15)">
              9
            </text>
          </g>
          
          <g  @click="typeClicked(8)" @mouseover="typeHover(8)"  id="7circleNumber">
            <circle :class="EightOver ? 'circleOver' : ''" id="_8circle" data-name="8circle" cx="162.5" cy="121" r="40" fill="#ff4b00"/>
            <text id="num8" :class="EightOver ? 'numberOver' : 'cls-14'" transform="translate(147.25 142.71)">
              8
            </text>
          </g>
          
          
        </g>
 

        <g  id="Lines">
          <g ref="_5to7" :class="fiveToSevenClass" id="_5to7" data-name="5to7">
            <path  d="M82.86 330.09l-1.79 34.19 11.56-15.5 19.46-.07-29.23-18.62zM84.52 333.96L263.5 674"/>
          </g>
          <g ref="_4to2" :class="fourToTwoClass" id="_4to2"  data-name="4to2">
            <path  d="M685.82 329.7l-28.36 20.52 19.72-1.02 12.51 14.93-3.87-34.43zM500.5 674l183.92-339"/>
          </g>
          <g ref="_2to8" :class="twoToEightClass" id="_2to8"  data-name="2to8">
            <path  d="M201.49 149.04L686.5 328M198.88 147.35l21.86 26.94-2.03-19.44 14.22-13.14-34.05 5.64z"/>
          </g>
          <g ref="_3to6" :class="threeToSixClass" id="_3to6" data-name="3to6">
            <path  d="M125.5 561h520M124.57 561.58l30.1 17.05-8.87-17.29 8.56-17.35-29.79 17.59z"/>
          </g>
          <g ref="_8to5" :class="eightToFiveClass"  id="_8to5" data-name="8to5">
            <path  d="M196.5 146l65 525M263.25 674.05l12.11-32.45-15.68 11.49-18.48-5.76 22.05 26.72z"/>
          </g>
          <g ref="_1to4"  :class="oneToFourClass" id="_1to4" data-name="1to4">
            <path  d="M501.48 669.89L571.5 148M500.57 674.49l15.48-26.97-12.83 5.53-10.55-12.06 7.9 33.5z"/>
          </g>
          <g ref="_9to3" :class="nineToThreeClass"  id="_9to3" data-name="9to3">
            <path  d="M379.5 81l264 476M644.05 558.97l1.96-34.59L634.43 540l-19.35-.03 28.97 19z"/>
          </g>
          <g ref="_7to1" :class="sevenToOneClass" id="_7to1" data-name="7to1">
            <path  d="M80.5 328l479-174M571.8 147.53l-34.5-3.17 15.21 12.12-.7 19.34 19.99-28.29z"/>
          </g>
          <g ref="_6to9" :class="sixToNineClass" id="_6to9" data-name="6to9">
            <path  d="M122.5 562l255-472M377.91 84.56l-27.78 20.68 19.41-1.14 12.39 14.87-4.02-34.41z"/>
          </g>
        </g>
      </g>

      
    </svg>

    <div class="pl-10" justify="center">
      <!--
      <v-checkbox v-model="showTriads" label="Show Triads"></v-checkbox>
      -->
      <div v-if="GutOver">
        Gut Triad
        <div class="grey--text body-2">
          Driven by instinct and anger
        </div>
      </div>
      <div v-if="HeadOver">
        Head Triad
        <div class="grey--text body-2">
          Driven by thougths and fear
        </div>
      </div>
      <div v-if="HeartOver">
        Heart Triad
        <div class="grey--text body-2">
          Driven by feelings and image
        </div>
      </div>

    </div>


  </div>
</template>

<script>
export default {
  name: 'EnneagramSymbol',
  props: {
    msg: String
  },
  methods: {

      typeClicked: function(typeNumber) {
          this.$emit('type-clicked', typeNumber)
      },

      typeHover: function(typeNumber) {

          this.OneOver = false
          this.TwoOver = false
          this.ThreeOver = false
          this.FourOver = false
          this.FiveOver = false
          this.SixOver = false
          this.SevenOver = false
          this.EightOver = false
          this.NineOver = false


          switch (typeNumber) {
            case 1:  this.OneOver = true;
              break;
            case 2:  this.TwoOver = true;
              break;
            case 3:  this.ThreeOver = true;
              break;
            case 4:  this.FourOver = true;
              break;
            case 5:  this.FiveOver = true;
              break;
            case 6:  this.SixOver = true;
              break;
            case 7:  this.SevenOver = true;
              break;
            case 8:  this.EightOver = true;
              break;
            case 9:  this.NineOver = true;
              break;

          }

          this.$emit('type-clicked', typeNumber)
      },

      getDefaultLineClass: function() {
        var returnClass = "cls-15"
        
        if (this.showTriads)
        {
            returnClass = "whiteLines"
        }

        return returnClass;
      }
  },
  computed: {
  
    

    nineToThreeClass: function() {
      var returnClass = this.getDefaultLineClass();
        
        if (this.ThreeOver) {
            returnClass = "integration"
        }

        if (this.NineOver) {
          returnClass = "disintegration"
        }

        return returnClass;
    },



    threeToSixClass: function() {
      var returnClass = this.getDefaultLineClass();
        
        if (this.SixOver) {
            returnClass = "integration"
        }

        if (this.ThreeOver) {
          returnClass = "disintegration"
        }

        return returnClass;
    },

    sixToNineClass: function() {
      var returnClass = this.getDefaultLineClass();
        
        if (this.SixOver) {
            returnClass = "disintegration"
        }

        if (this.NineOver) {
          returnClass = "integration"
        }

        return returnClass;
    },

    fourToTwoClass: function() {
      var returnClass = this.getDefaultLineClass();
        
        if (this.TwoOver) {
            returnClass = "integration"
        }

        if (this.FourOver) {
          returnClass = "disintegration"
        }

        return returnClass;
    },

    twoToEightClass: function() {
      var returnClass = this.getDefaultLineClass();
        
        if (this.TwoOver) {
            returnClass = "disintegration"
        }

        if (this.EightOver) {
          returnClass = "integration"
        }

        return returnClass;
    },

    eightToFiveClass: function() {
      var returnClass = this.getDefaultLineClass();
        
        if (this.EightOver) {
            returnClass = "disintegration"
        }

        if (this.FiveOver) {
          returnClass = "integration"
        }

        return returnClass;
    },


    fiveToSevenClass: function() {
      var returnClass = this.getDefaultLineClass();
        
        if (this.SevenOver) {
            returnClass = "integration"
        }

        if (this.FiveOver) {
          returnClass = "disintegration"
        }

        return returnClass;
    },

    sevenToOneClass: function() {
      var returnClass = this.getDefaultLineClass();
        
        if (this.SevenOver) {
            returnClass = "disintegration"
        }

        if (this.OneOver) {
          returnClass = "integration"
        }

        return returnClass;
    },

    oneToFourClass: function() {
        var returnClass = this.getDefaultLineClass();
        
        if (this.OneOver) {
            returnClass = "disintegration"
        }

        if (this.FourOver) {
          returnClass = "integration"
        }

        return returnClass;
    }
  },
  data: function () {
    return {
      showTriads : true,
      OneOver: false,
      TwoOver: false,
      ThreeOver: false,
      FourOver: false,
      FiveOver: false,
      SixOver: false,
      SevenOver: false,
      EightOver: false,
      NineOver: false,

      GutOver: false,
      HeadOver: false,
      HeartOver: false,
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>


.heartOver{
  stroke: black;
  stroke-width: 2pt;
  transform: translate(10px, 5px);
  cursor: pointer;
}

.headOver{
  stroke: black;
  stroke-width: 2pt;
  transform: translate(-10px, 5px);
  cursor: pointer;
}

.gutOver{
  stroke: black;
  stroke-width: 2pt;
  transform: translate(0px, -10px);
  cursor: pointer;
}

.disintegration {
  stroke: red;
  fill: red;
  stroke-width: 4pt;
}

.integration {
  stroke: green;
  fill: green;
  stroke-width: 4pt;
}


.numberOver {
  fill: black;
  font-size:60px;
  font-family:ArialMT,Arial;
  cursor: pointer;
}

.circleOver {
  stroke: black;
  stroke-width: 2pt;
  fill: white;
  cursor: pointer;
}


svg {
  padding: 1em;
}


.whiteLines {
  stroke: white;
  stroke-miterlimit:10;
  stroke-width:4px;
  fill: white;
}


.cls-15 {
  stroke:#aaa;
  stroke-miterlimit:10;
  stroke-width:4px;
  fill:#aaa
}

.cls-14 {
  font-size:60px;
  fill:#fff;
  font-family:ArialMT,Arial
  }




</style>
